import { signIn, useSession } from 'next-auth/react';
import { useUserContext } from 'contexts/UserContext';
import { generateRecaptchaToken } from 'helpers/reCaptcha';
import { userLogout } from 'helpers/Logout';
import { randomStringGenerator } from 'helpers/randomStringGenerator';
import { useRouter } from 'next/router';
import axios from 'axios';
import { signOut } from 'next-auth/react';
import { fireToast } from 'helpers/Toasts';
import {
  isExperimentRunning,
  isInTheExperiment,
} from 'helpers/optimize/optimize';

export const keycloakLogout = async (callbackUrl?: string) => {
  try {
    await axios.get('/api/auth/keycloak_signout');
    await signOut(callbackUrl ? { callbackUrl } : { redirect: false });
  } catch (error) {
    console.log(error);
    throw new Error('unable to signout');
  }
};

const useAuthOptions = () => {
  const {
    isLegacyAuth,
    user,
    setIsLoginModalOpen,
    setIsSignUpModalOpen,
    dispatchUser,
    setddRecommendedUser,
    consentOptions,
  } = useUserContext();
  const { data: session } = useSession();
  const { asPath } = useRouter();

  const username = user?.name || '';
  const legacyAuth =
    !isExperimentRunning() || isLegacyAuth || (!!user && !session?.user);
  const isLoggedInKeycloakUser = !!session?.user;

  const handleLogin = () => {
    if (legacyAuth) {
      setIsLoginModalOpen(true);
      generateRecaptchaToken('login_modal');
    } else {
      signIn('keycloak', {
        callbackUrl: `/signin?callbackUrl=${asPath}`,
      });
    }
  };
  const handleSignup = () => {
    if (legacyAuth) {
      generateRecaptchaToken('signup_modal');
      setIsSignUpModalOpen(true);
    } else {
      signIn('keycloak', {
        callbackUrl: `/signin?callbackUrl=${asPath}`,
      });
    }
  };
  const handleLogout = async () => {
    if (isLoggedInKeycloakUser) {
      try {
        await keycloakLogout();
      } catch (error) {
        fireToast({
          type: 'ERROR',
          text: 'Oops! Something went wrong, please try again later',
        });
        return;
      }
    }
    /** TODO:
     * Local logout needs to take set-cookie header from logout response and apply it to localhost domain cookies (removes DDUS etc)
     */
    await userLogout(dispatchUser, username);
    consentOptions?.functional && setddRecommendedUser(randomStringGenerator());
  };

  const isAuthenticated = Boolean(username?.length > 0);

  // TODO: AccessToken null unless experiment running and you are in the experiment
  const isKeycloak = isInTheExperiment() && !!user && !!session?.user;
  const accessToken = isKeycloak ? session?.accessToken : undefined;

  return {
    legacyAuth,
    handleLogin,
    handleSignup,
    handleLogout,
    isAuthenticated,
    accessToken,
  };
};

export { useAuthOptions };
